import Lightbox from "@stimulus-components/lightbox";

export default class extends Lightbox {
  get defaultOptions() {
    return {
      selector: "a",
    };
  }
}
